import { render, staticRenderFns } from "./Sentenciado.vue?vue&type=template&id=74b2a078&scoped=true&"
import script from "./Sentenciado.vue?vue&type=script&lang=js&"
export * from "./Sentenciado.vue?vue&type=script&lang=js&"
import style0 from "./Sentenciado.vue?vue&type=style&index=0&id=74b2a078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b2a078",
  null
  
)

export default component.exports